import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import DeleteModal from '../DeleteModal/DeleteModal';
import { withRouter } from 'react-router';
import moment from 'moment';
import './styles/userBenefits.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedUserBenefits(props) {

  const { token, userId } = props;

  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [benefits, setBenefits] = useState([]);
  const [applications, setApplications] = useState([]);
  const [requestedBenefits, setRequestedBenefits] = useState([]);
  const [benefitToDelete, setBenefitToDelete] = useState();
  const [requestedBenefitToDelete, setRequestedBenefitToDelete] = useState();
  const [applicationToDelete, setApplicationToDelete] = useState();
  const [tab, setTab] = useState(0);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (benefitToDelete || applicationToDelete || requestedBenefitToDelete) setShowDeleteModal(true);
  }, [benefitToDelete, applicationToDelete, requestedBenefitToDelete]);

  useEffect(() => {
    if (tab === 0) {
      setApplicationToDelete();
      setRequestedBenefitToDelete();
    } else {
      setBenefitToDelete();
    }
  }, [tab]);

  const getData = async () => {
    setLoading(true);

    const benefitsProm = await fetch(`${apiUrl}/benefits/get/user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const benefitsResp = await benefitsProm.json();

    if (benefitsResp.success) {
      setBenefits(benefitsResp.benefits);
      setApplications(benefitsResp.applications);
      setRequestedBenefits(benefitsResp.requestedBenefits);
    }

    setLoading(false);
  };

  const closeDeleteModal = () => {
    setBenefitToDelete();
    setApplicationToDelete();
    setRequestedBenefitToDelete();
    setShowDeleteModal(false);
  };

  const deleteProduct = async () => {

    let deleteProm;

    if (applicationToDelete) {

      deleteProm = await fetch(`${apiUrl}/benefitApplications/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          id: applicationToDelete._id
        })
      });

    } else if (benefitToDelete) {

      deleteProm = await fetch(`${apiUrl}/benefits/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          id: benefitToDelete._id
        })
      });

    } else if (requestedBenefitToDelete) {

      deleteProm = await fetch(`${apiUrl}/requestedBenefits/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          id: requestedBenefitToDelete._id
        })
      });

    }

    const deleteResp = await deleteProm.json();

    if (!deleteResp.success) alert('Ocurrió un error, inténtalo nuevamente.');
    else getData();

    closeDeleteModal();
  };

  const deleteText =
    benefitToDelete ? `la ayuda ${benefitToDelete.name}` :
    applicationToDelete ? `tu aplicación a esta ayuda` :
    requestedBenefitToDelete ? `la solicitud ${requestedBenefitToDelete.name}` :'';

  if (loading) {
    return (
      <div className="user-benefits-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="user-benefits-component">
      <Container>
        <Row>
          <Col>
            <h3>Muro de la solidaridad</h3>

            <ButtonGroup>
              <Button variant={tab === 0 ? 'secondary' : 'outline-secondary'} onClick={() => setTab(0)}>
                Ofrecidas
              </Button>
              <Button variant={tab === 1 ? 'secondary' : 'outline-secondary'} onClick={() => setTab(1)}>
                Solicitadas
              </Button>
            </ButtonGroup>

            {
              tab === 0 ?
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tipo</th>
                    <th>Categoría</th>
                    <th>Fecha de creación</th>
                    <th>Estado</th>
                    <th>Monto</th>
                    <th>Nombre</th>
                    <th style={{ textAlign: 'center' }}>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    benefits.map((benefit, index) =>
                      <tr key={benefit._id}>
                        <td>{index + 1}</td>
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <>
                            <td>Ayuda particular</td>
                            <td>-</td>
                          </> :
                          <>
                            <td>Bono</td>
                            <td>{benefit.category}</td>
                          </>
                        }
                        <td>{moment(benefit.dateCreated).format('YYYY-MM-DD')}</td>
                        <td>
                          {
                            benefit.status === 'PENDING' ? 'Pendiente' :
                            benefit.status === 'AVAILABLE' ? 'Disponible' :
                            benefit.status === 'DECLINED' ? 'Rechazada' :
                            'Asignada'
                          }
                        </td>
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <>
                            <td>-</td>
                            <td>{benefit.name}</td>
                          </> :
                          <>
                            <td>{formatMoney(Math.floor(benefit.amount))}</td>
                            <td>-</td>
                          </>
                        }
                        {
                          (benefit.benefitType === 'CUSTOM') ?
                          <td className="options">
                            {
                              benefit.status === 'PENDING' ?
                              <>
                                <Button
                                  className="delete-btn"
                                  variant="danger"
                                  style={{ margin: '0' }}
                                  onClick={() => {
                                    setApplicationToDelete();
                                    setRequestedBenefitToDelete();
                                    setBenefitToDelete(benefit);
                                  }}
                                >
                                  Eliminar
                                </Button>
                                <Button className="edit-btn" variant="info" onClick={() => props.history.push(`/dashboard/seccion_solidaria/editar?id=${benefit._id}`)}>
                                  Editar
                                </Button>
                              </> :
                              <Button className="edit-btn" variant="info" onClick={() => props.history.push(`/dashboard/seccion_solidaria/ver?id=${benefit._id}`)}>
                                Ver
                              </Button>
                            }
                          </td> :
                          <td></td>
                        }
                      </tr>
                    )
                  }
                </tbody>
              </Table> :
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tipo</th>
                    <th>Categoría</th>
                    <th>Fecha de aplicación</th>
                    <th>Estado</th>
                    <th>Monto</th>
                    <th>Nombre</th>
                    <th style={{ textAlign: 'center' }}>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    requestedBenefits.map((benefit, index) =>
                      <tr key={benefit._id}>
                        <td>{index + 1}</td>
                        <td>Solicitud de ayuda</td>
                        <td>-</td>
                        <td>{moment(benefit.dateCreated).format('YYYY-MM-DD')}</td>
                        <td>
                          {
                            benefit.status === 'REQUESTED' ? 'Solicitada' :
                            benefit.status === 'RESOLVED' ? 'Resuelta' :
                            'Rechazada'
                          }
                        </td>
                        <td>-</td>
                        <td>{benefit.name}</td> 
                        {
                          benefit.status === 'REQUESTED' ?
                          <td className="options">
                            <Button
                              className="delete-btn"
                              variant="danger"
                              onClick={() => {
                                setBenefitToDelete();
                                setApplicationToDelete();
                                setRequestedBenefitToDelete(benefit);
                              }}
                            >
                              Eliminar
                            </Button>
                          </td> :
                          <td></td>
                        }
                      </tr>
                    )
                  }
                  {
                    applications.map((application, index) =>
                      <tr key={application._id}>
                        <td>{index + 1}</td>
                        {
                          application.type === 'CUSTOM' ?
                          <>
                            <td>Ayuda particular</td>
                            <td>-</td>
                          </> :
                          <>
                            <td>Bono</td>
                            <td>{application.category}</td>
                          </>
                        }
                        <td>{moment(application.dateCreated).format('YYYY-MM-DD')}</td>
                        <td>
                          {
                            application.status === 'PENDING' ? 'Pendiente' :
                            application.status === 'APPROVED' ? 'Aprobada' :
                            'Rechazada'
                          }
                        </td>
                        {
                          application.type === 'CUSTOM' ?
                          <>
                            <td>-</td>
                            <td>{application.benefit.name}</td>
                          </> :
                          <>
                            <td>{formatMoney(Math.floor(application.benefitAmount))}</td>
                            <td>-</td>
                          </>
                        }
                        {
                          application.status === 'PENDING' ?
                          <td className="options">
                            <Button
                              className="delete-btn"
                              variant="danger"
                              onClick={() => {
                                setBenefitToDelete();
                                setRequestedBenefitToDelete();
                                setApplicationToDelete(application);
                              }}
                            >
                              Eliminar
                            </Button>
                          </td> :
                          <td></td>
                        }
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            }
          </Col>
        </Row>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        text={deleteText}
        onClose={closeDeleteModal}
        onDelete={deleteProduct}
      />
    </div>
  );
}

const UserBenefits = connect(select)(ConnectedUserBenefits);

export default withRouter(UserBenefits);
